import React from 'react'
// import InstagramFeed from './InstagramFeed'
import './Footer.css'

export default () => (
  <div>
    {/* <h2 className="taCenter">
      Follow us{' '}
      <a href="https://instagram.com/thrivegoldcoast/">@thrivegoldcoast</a>
    </h2> */}
    <br />
    {/* <InstagramFeed count="8" /> */}
    <footer className="footer">
      <div className="container">
      <div className="taCenter">
          <span>
            <a href="https://twitter.com/sugimotosyo"><img src="https://img.icons8.com/ios-glyphs/30/000000/twitter.png"/></a>
            <a href="https://github.com/sugimotosyo"><img src="https://img.icons8.com/ios-glyphs/30/000000/github.png"/></a>
            <a href="https://www.facebook.com/syouhei.sugimoto.5"><img src="https://img.icons8.com/ios-glyphs/30/000000/facebook-new.png"/></a>
            <a href="https://www.linkedin.com/in/%E7%BF%94%E5%B9%B3-%E6%9D%89%E6%9C%AC-548677170/"><img src="https://img.icons8.com/ios-glyphs/30/000000/linkedin.png"/></a>
          </span>
        </div>
        <br/>
        <div className="taCenter">
          <span>
            © Copyright {new Date().getFullYear()} All rights reserved. Crafted by{' '}
            <a href="https://green-luck.com/">Shohei Sugimoto</a>.
          </span>
        </div>
      </div>
    </footer>
  </div>
)
